import React from "react";

//建立 Context
const AppContext = React.createContext();

export default AppContext;
